<div class="container">
  <div class="d-flex">
    <div class="w-100">
      <div class="panel panel-primary">
        <div class="panel-heading" id="accordion"></div>
        <div class="">
          <div class="panel-body">
            <ul *ngIf="!loading" class="chat" [style.height.px]="height">
              <!-- <li *ngFor="let groups of groupArray">
                
                <p *ngFor="let chat of groups.chats">
                  {{ chat.message }}
                </p>
              </li> -->

              <div *ngFor="let groups of groupArray; let i = index">
                <p class="text-center text-muted pt-4">{{ groups.date }}</p>
                <li
                  (mouseover)="mouseOvered = true"
                  *ngFor="let chat of groups.chats"
                  [ngClass]="[
                    chat['rep']['id'] == this.identity.sub ? 'right' : 'left'
                  ]"
                  class="left clearfix mt-2 msg-container d-flex"
                >
                  <span
                    class="chat-img mx-4"
                    [ngClass]="[
                      chat['rep']['id'] == this.identity.sub ? '' : 'pull-left '
                    ]"
                  >
                    <div class="circle">
                      <span
                        >{{ chat["rep"]["name"][0]
                        }}{{ chat["rep"]["surname"][0] }}</span
                      >
                    </div>

                    <!-- <img *ngIf="chat['rep']['id'] != this.identity.sub" width="40px"
                                      style="border-radius: 50px"
                                      src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{chat['rep']['name'][0]}}{{chat['rep']['surname'][0]}}"
                                      alt="User Avatar" class="img-circle" /> -->
                    <!-- <img *ngIf="chat['rep']['id'] == this.identity.sub" width="40px"
                                      style="border-radius: 50px"
                                      src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{chat['rep']['name'][0]}}{{chat['rep']['surname'][0]}}"
                                      alt="User Avatar" class="img-circle" /> -->
                  </span>

                  <div class="d-flex w-100 justify-content-between">
                    <div
                      class="btn-group dropright"
                      *ngIf="chat['rep']['id'] == this.identity.sub"
                    >
                      <button
                        type="button"
                        class="dropdown-toggle icon-btn"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i
                          style="font-size: 20px; cursor: pointer"
                          class="material-icons"
                        >
                          more_vert
                        </i>
                      </button>
                      <ul class="dropdown-menu">
                        <li class="dropdown-item">
                          <button
                            (click)="deleteChat(chat['id'])"
                            class="icon-btn w-100"
                          >
                            <i
                              style="font-size: 20px; cursor: pointer"
                              class="material-icons trash-btn mr-2"
                            >
                              delete
                            </i>
                            <span>Remove</span>
                          </button>
                        </li>
                        <li
                          class="dropdown-item"
                          *ngIf="chat['rep']['id'] === identity.sub"
                        >
                          <button
                            (click)="editChat(chat['id'], chat['message'])"
                            class="icon-btn w-100"
                          >
                            <i
                              style="font-size: 20px; cursor: pointer"
                              class="material-icons edit-btn mr-2"
                            >
                              create
                            </i>
                            <span>Edit</span>
                          </button>
                        </li>
                        <li
                          class="dropdown-item"
                          *ngIf="chat['historialMessage']"
                        >
                          <button
                            (click)="
                              showHistory(chat['historialMessage'], chat['id'])
                            "
                            class="icon-btn w-100"
                          >
                            <i
                              style="font-size: 20px; cursor: pointer"
                              class="material-icons mr-2"
                            >
                              schedule
                            </i>
                            <span class="text-left">Show Message History</span>
                          </button>
                        </li>
                        <li class="dropdown-item" *ngIf="chat['viewMessage']">
                          <button
                            (click)="showViews(chat['viewMessage'], chat['id'])"
                            class="icon-btn w-100"
                          >
                            <i
                              style="font-size: 20px; cursor: pointer"
                              class="material-icons mr-2"
                            >
                              remove_red_eye
                            </i>
                            <span class="text-left">Show Views</span>
                          </button>
                        </li>
                      </ul>
                      <div *ngIf="show && chat['id'] === idChat">
                        <ul
                          style="height: 88px; width: 150px; overflow: auto"
                          class="p-2 chat-container"
                        >
                          <li *ngFor="let views of viewsArray; let i = index">
                            {{ views.user }}
                          </li>
                        </ul>
                        <button
                          style="font-size: 0.75rem"
                          class="hide-btn icon-btn font-weight-bold mt-2"
                          [ngClass]="[
                            chat['rep']['id'] == this.identity.sub
                              ? 'justify-content-end'
                              : 'justify-content-start'
                          ]"
                          (click)="hideViews()"
                        >
                          Hide Views
                        </button>
                      </div>
                    </div>
                    <!-- <small *ngIf="chat['rep']['id'] == this.identity.sub">
                      <button
                        (click)="deleteChat(chat['id'])"
                        class="trash-btn"
                      >
                        <i
                          style="font-size: 20px; cursor: pointer"
                          class="material-icons"
                        >
                          face
                        </i>
                      </button>
                    </small> -->

                    <div 
                    [ngClass]="[
                    showEdit && chat['id'] === idChat ? 'w-100' : ''
                  ]"
                    >
                      <div
                        *ngIf="!showEdit || (showEdit && chat['id'] !== idChat)"
                        class="d-flex justify-content-between"
                        [ngClass]="[
                          chat['rep']['id'] == this.identity.sub ? '' : ''
                        ]"
                      >
                        <div class="">
                          <div class="d-flex flex-column">
                            <div
                              *ngIf="historialArray && idChat === chat['id']"
                            >
                              <ul class="p-0">
                                <div
                                  *ngFor="
                                    let historial of historialArray;
                                    let i = index
                                  "
                                  class="d-flex flex-column text-container mb-2"
                                  [ngClass]="[
                                    chat['rep']['id'] == this.identity.sub
                                      ? 'justify-content-end text-right text-identity-history ml-4'
                                      : 'text-other-identity-history mr-4'
                                  ]"
                                >
                                  <li class="msg">
                                    {{ historial.Message }}
                                  </li>
                                </div>
                              </ul>
                            </div>
                            <strong
                              [ngClass]="[
                                chat['rep']['id'] == this.identity.sub
                                  ? 'right'
                                  : 'left'
                              ]"
                              style="font-size: 0.75rem"
                              class="text-muted"
                              >{{ chat["rep"]["name"] }}
                              {{ chat["rep"]["surname"] }}
                            </strong>

                            <div
                              class="d-flex flex-column text-container"
                              [ngClass]="[
                                chat['rep']['id'] == this.identity.sub
                                  ? 'justify-content-end text-right text-identity ml-4'
                                  : 'text-other-identity mr-4'
                              ]"
                            >
                              <span class="msg"> {{ chat["message"] }}</span>
                              <div
                                class="d-flex d-flex align-items-center mt-2 justify-content-end"
                                style="font-size: 0.75rem"
                              >
                                <small class="d-flex align-items-center">
                                  <i
                                    style="font-size: 13px; margin-right: 5px"
                                    class="material-icons"
                                    >access_time</i
                                  >
                                  {{
                                    hour(
                                      chat["createdAt"]["timestamp"] * 1000
                                        | date : "short"
                                    )
                                  }}
                                </small>
                                <i
                                  *ngIf="chat['readIt'] == 'yes'"
                                  style="font-size: 18px; color: #1aa0f0"
                                  class="material-icons ml-2"
                                  >done</i
                                >
                              </div>
                            </div>
                            <div
                              class="d-flex"
                              [ngClass]="[
                                chat['rep']['id'] == this.identity.sub
                                  ? 'justify-content-end'
                                  : 'justify-content-start'
                              ]"
                            >
                              <strong
                                *ngIf="chat['historialMessage']"
                                style="font-size: 0.75rem"
                                class="text-muted"
                                [ngClass]="[
                                  chat['rep']['id'] == this.identity.sub
                                    ? 'text-right'
                                    : 'text-left'
                                ]"
                                >Edited
                              </strong>
                              <button
                                style="font-size: 0.75rem"
                                class="hide-btn icon-btn font-weight-bold"
                                [ngClass]="[
                                  chat['rep']['id'] == this.identity.sub
                                    ? 'justify-content-end'
                                    : 'justify-content-start'
                                ]"
                                *ngIf="hideEdit && idChat == chat['id']"
                                (click)="hideChat()"
                              >
                                Hide Edit
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- <form
                        *ngIf="showEdit"
                        action="
                          "
                      >
                        <mat-form-field class="example-full-width">
                          <mat-label>Favorite food</mat-label>
                          <input
                            matInput
                            placeholder="Ex. Pizza"
                            [(ngModel)]="messageEdit"
                          />
                        </mat-form-field>
                      </form> -->
                      </div>

                      <form
                        class="w-100 d-flex"
                        *ngIf="showEdit && chat['id'] === idChat"
                        action=""
                      >
                        <!-- <textarea
                          class="form-control"
                          placeholder="Type message here"
                          [(ngModel)]="messageEdit"
                        ></textarea> -->
                        <app-message-input
                          class="w-100"
                          [isEdit]="true"
                          (sendMessage)="editMsg($event, chat['id'])"
                          [valueEdit]="messageEdit"
                        ></app-message-input>
                        <div class="d-flex justify-content-end align-items-center">
                          <button
                          style=" margin-top: 12px;
                          margin-left: 1rem;
                        "
                            (click)="cancelEdit(chat['id'])"
                            class="btn btn-info"
                          >
                            Cancel
                          </button>
                          <!-- <button
                            (click)="saveEdit(chat['id'])"
                            class="btn btn-success"
                          >
                            Save
                          </button> -->
                        </div>
                      </form>
                    </div>
                    <div
                      class="d-flex"
                      *ngIf="
                        chat['rep']['id'] !== identity.sub &&
                        identity.role == 'ADMINISTRATOR'
                      "
                    >
                      <div *ngIf="show && chat['id'] === idChat">
                        <ul
                          class="p-2 chat-container"
                          style="height: 88px; width: 150px; overflow: auto"
                        >
                          <li [title]="date(views.createdAt)" *ngFor="let views of viewsArray; let i = index">
                            {{ views.user }}
                          </li>
                        </ul>
                        <button
                          style="font-size: 0.75rem"
                          class="hide-btn icon-btn font-weight-bold mt-2"
                          [ngClass]="[
                            chat['rep']['id'] == this.identity.sub
                              ? 'justify-content-end'
                              : 'justify-content-start'
                          ]"
                          (click)="hideViews()"
                        >
                          Hide Views
                        </button>
                      </div>

                      <div class="btn-group dropright">
                        <button
                          type="button"
                          class="dropdown-toggle icon-btn"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i
                            style="font-size: 20px; cursor: pointer"
                            class="material-icons"
                          >
                            more_vert
                          </i>
                        </button>
                        <ul class="dropdown-menu">
                          <li class="dropdown-item">
                            <button
                              (click)="deleteChat(chat['id'])"
                              class="icon-btn w-100"
                            >
                              <i
                                style="font-size: 20px; cursor: pointer"
                                class="material-icons trash-btn mr-2"
                              >
                                delete
                              </i>
                              <span>Remove</span>
                            </button>
                          </li>
                          <li
                            class="dropdown-item"
                            *ngIf="chat['historialMessage']"
                          >
                            <button
                              (click)="
                                showHistory(
                                  chat['historialMessage'],
                                  chat['id']
                                )
                              "
                              class="icon-btn w-100"
                            >
                              <i
                                style="font-size: 20px; cursor: pointer"
                                class="material-icons mr-2"
                              >
                                schedule
                              </i>
                              <span class="text-left"
                                >Show Message History</span
                              >
                            </button>
                          </li>
                          <li class="dropdown-item" *ngIf="chat['viewMessage']">
                            <button
                              (click)="
                                showViews(chat['viewMessage'], chat['id'])
                              "
                              class="icon-btn w-100"
                            >
                              <i
                                style="font-size: 20px; cursor: pointer"
                                class="material-icons mr-2"
                              >
                                remove_red_eye
                              </i>
                              <span class="text-left">Show Views</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </ul>
          </div>
          <div style="margin-top: 20px" class="panel-footer">
            <mat-progress-bar
              style="width: 80%"
              *ngIf="loading2 || loading || saving"
              id="loadingbar"
              mode="indeterminate"
            ></mat-progress-bar>
            <app-message-input
            
              (sendMessage)="sendMessage($event)"
              [deshabilitado]="disabled"
            ></app-message-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
